/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Type_Radiant_HeatInputs */



/**
* | output |
* | --- |
* | "Radiant panel" |
*
* @param {Heating_Network_Type_Radiant_HeatInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_type_radiant_heat = /** @type {((inputs?: Heating_Network_Type_Radiant_HeatInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Network_Type_Radiant_HeatInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Radiant panel")
	return /** @type {LocalizedString} */ ("Panneau rayonnant")
});